

import React from 'react';
import styled from "styled-components";
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import axios from 'axios';
import https from "https";
import realtimeDB, { db } from '../../Utils/api';

const Container=styled.div`
cursor: pointer;
margin: 0 5px;`;

const ButtonWhatsapp=styled.div`
color:inherit;
text-decoration: none;`;

const Letter=styled.div`
height: 20px;
width: 20px;
background-color: rgb(0,136,255);
color: white;
text-align: center;
position:absolute;
border-radius: 100%;
margin-top: -20px;
margin-left: 10px;`;

const getRoute=letter=>
{
    if(letter==="S")
    {
        return "siguiente"
    }
    if(letter==="?")
    {
        return "?";
    }
    if(letter==="X")
    {
        return "cierre";
    }
}

const WhatsappButtonLink = ({customer,letter,setAlertaTipo,setMensajeAlerta}) =>
{
    const handleClick= async () =>
    {
        if(letter==="C")
        {
            const WhatsappLink=`https://web.whatsapp.com/send?phone=${customer.data.phone}&text=`;
            window.open(WhatsappLink,"_blank")   
        }
        else
        {
            const nameRoute=getRoute(letter)

            try
            {
                const agent = new https.Agent({  
                    rejectUnauthorized: false
                });

                const EnviarAlWhatsapp= await window.axios.post(`/whatsapp/${nameRoute}`,customer.data,{httpsAgent:agent});
                if(EnviarAlWhatsapp.data==="OK")
                {
                    setAlertaTipo("success");
                    setMensajeAlerta(`Whatsapp ${nameRoute} enviado`);
                }

                if(letter==="X")
                {
                    await realtimeDB.ref("/Customers").child(customer.id).update({status:"cancelled"});
                }
            }
            catch(error)
            {
                console.log("data",error.response.data)
                setMensajeAlerta(error.response.data.statusmsg);
                setAlertaTipo("error");
            }
        }
    }

    return <Container onClick={handleClick} key={`${customer.id} - ${letter}`}>
            <ButtonWhatsapp><WhatsAppIcon></WhatsAppIcon></ButtonWhatsapp>
            <Letter>{letter}</Letter>
    </Container>
}

export default WhatsappButtonLink;